import Vue from 'vue';
import Vuex from 'vuex';
import message from './message';
Vue.use(Vuex);
let store = new Vuex.Store({
    modules: {
        message
    }
});
export const showInfo = m => store.dispatch('message/info', m);
export const showError = m => store.dispatch('message/error', m);
export const showSuccess = m => store.dispatch('message/success', m);
export default store;
